import { useDispatch, useSelector } from "react-redux";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";

import {getThotAutoclavesMonitor} from "../../../actions/thotActions";
import AutoclavePlantGrid from "./AutoclavePlantGrid";
import {FormControl, InputLabel, MenuItem, Select, Switch, Typography} from "@material-ui/core";
import {useParams} from "react-router-dom";
import {useLocation, useSearchParams} from "react-router-dom";




const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    listaOS: {
      display: 'flex',
      flexDirection: "row",
      flexWrap: "wrap",
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        alignItems: 'flex-start',
        justifyItems: 'flex-start',

    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    texto: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        flexGrow: 12,
        flexFlow: 'column',
        textAlign: 'center',
        justifyContent: "flex-start",
        alignItems: "center"
    }
}));

const ThotAutoclavesMonitor = (props) => {
    const classes = useStyles();

    const uId =  useSelector(state => state.auth.userId);
    const demo = uId === 268;







    const [show, setShow] = useState(false);

    const st = useSelector(state => state);
    const autoclavesMonitor = useSelector(state => state.thot.autoclavesMonitor);
    const isFetchingAutoclavesMonitor = useSelector(state => state.thot.isFetchingAutoclavesMonitor);
    const [primeiroTnt, setPrimeiroTnt] = useState(-1);
    const lastTntIx = useSelector(state => state.thot.lastAutoclaveTntIx);
    const [contador,setContador] = useState(0);

    const [bMostrarComm, setbMostrarComm] = useState((localStorage.getItem('thotAutoclaveDetalhes') !== null )? (localStorage.getItem('thotAutoclaveDetalhes') === '1') : false);
    const [estabelecimentoTipo, setEstabelecimentoTipo] = useState(0)

    const [tempoRefresh, setTempoRefresh] = useState(2);

    const dispatch = useDispatch();

    useEffect(()=>{

        const interval=setInterval(()=>{
            setContador(contador +1);
            if (!isFetchingAutoclavesMonitor) {
                dispatch(getThotAutoclavesMonitor());
            }
        },tempoRefresh * 1000);
        return()=>clearInterval(interval)
    },[contador]);

    useEffect( () => {
        dispatch(getThotAutoclavesMonitor());
    }, []);


    useEffect( () => {

        if (!isFetchingAutoclavesMonitor) {
            if (primeiroTnt > 0 && lastTntIx === primeiroTnt) {
                setTempoRefresh(10);
            }
            if (primeiroTnt === -1 && lastTntIx > 0) {
                setPrimeiroTnt(lastTntIx);
            }
        }

    }, [isFetchingAutoclavesMonitor]);


    const onFilterClick = () => {
        dispatch(getThotAutoclavesMonitor());
    }

    const handleChangeComm = () => {
        const x = !bMostrarComm?  1 : 0;
        localStorage.setItem('thotAutoclaveDetalhes', x)
        setbMostrarComm(!bMostrarComm);

    }

    return (
        <React.Fragment>

                <Grid item container item xs={12} lg={12} xl={12} style={{display: 'flex', flexWrap: 'noWrap', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <Grid item container className={classes.texto}  style={{display: 'flex', alignItems: 'flex-start'}}>
                        <Switch checked={bMostrarComm} onChange={handleChangeComm} name="filtroTodosKpis"  />
                        <Typography>DETALHES</Typography>
                    </Grid>
                    <Grid  item container item xs={12} lg={12} xl={12} style={{display: 'flex', alignItems: 'flex-start'}}>
                            <InputLabel id="demo-simple-select-label">PLANTAS</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={estabelecimentoTipo}
                                label="Tipo Planta"
                                onChange={(e) => setEstabelecimentoTipo(e.target.value)}
                            >
                                <MenuItem value={0}>Todos</MenuItem>
                                <MenuItem value={1}>Tipler</MenuItem>
                                <MenuItem value={2}>Solução Tipler</MenuItem>
                                <MenuItem value={10}>Tipler+Solução</MenuItem>
                                <MenuItem value={3}>Borex</MenuItem>
                                <MenuItem value={4}>Marca Própria</MenuItem>
                                <MenuItem value={5}>Outros</MenuItem>
                            </Select>
                    </Grid>
                </Grid>

            <Grid container item className={classes.listaOS} style={{ }}>


                    {  autoclavesMonitor.length > 0 &&
                        <React.Fragment>

                            { autoclavesMonitor
                                .filter( a =>  ((estabelecimentoTipo === 0) || a.estabelecimentoTipoId === estabelecimentoTipo ||
                                    (estabelecimentoTipo === 10 && (a.estabelecimentoTipoId  === 1 || a.estabelecimentoTipoId === 2) )   ) )
                                .sort(function(a, b) {
                                    if (!a.tDescricao) { return 0; }
                                    if (a.tDescricao < b.tDescricao) { return -1; }
                                    if (a.tDescricao > b.tDescricao) { return 1; }
                                    return 0;
                                })
                                .map( (e, ix : number) => {
                                    return (<AutoclavePlantGrid key={e.ix} registro={e} index={ix} mostrarComm={bMostrarComm} /> );
                                }) }
                        </React.Fragment>

                    }


            </Grid>

            { !bMostrarComm &&
                <React.Fragment>
                    <br/>
                     <Grid container id={'gridLegenda'} item style={{display: 'flex', flexDirection: 'column', flexWrap: 'wrap'}} >
                         { demo && <Typography>DEMONSTRAÇÃO: SÃO APRESENTADOS NUMEROS ALEATORIOS</Typography>}
                         <Typography>Legenda:</Typography>
                         <Typography>Planta - Autoclave | Num Ciclos Mês Atual | Num Ciclos Mês Anterior</Typography>
                         <Typography>S/COM: Sem comunicacao com autoclave ou sem comunicacao cloud a mais de 20min.</Typography>
                         <Typography>Laranja: Autoclave sem comunicacao com cloud a mais de 6 horas ou 1h se estava em ciclo.</Typography>
                         <Typography>Vermelho: Autoclave sem comunicacao com cloud a mais de 4 dias.</Typography>

                      </Grid>
                </React.Fragment>
            }


        </React.Fragment>
    )

}

export default ThotAutoclavesMonitor;
